<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')">
      <div
        class="modal-wrapper middle"
        style="position: absolute; overflow-y: auto"
      >
        <div class="modal-container modal-dialog" @click.stop>
          <div class="modal-header">
            <h3>&nbsp;</h3>
            <button
              type="button"
              class="close close-corner"
              @click="$emit('close')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin: 0; padding: 5px">
            <slot name="body"> </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted: function () {
    let vm = this
    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  }
}
</script>

<style scoped></style>
